import { DeliveryEstimate } from "@redotech/redo-conversion-core-common/conversion/conversion-autocheck";
import {
  DeliveryEstimatePortal,
  useDeliveryEstimatePortals,
} from "./use-delivery-estimate-portals";

const CART_DELIVERY_ESTIMATE_CONTAINER_ID =
  "redo-delivery-estimate-cart-container";

export function useCartRenderPortals({
  deliveryEstimate,
}: {
  deliveryEstimate: DeliveryEstimate;
}): DeliveryEstimatePortal[] {
  return useDeliveryEstimatePortals({
    selectorConfigs: deliveryEstimate.cartSelectors,
    containerId: CART_DELIVERY_ESTIMATE_CONTAINER_ID,
  });
}
